import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatCardModule } from '@angular/material/card'
import { MatIcon } from '@angular/material/icon'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatExpansionModule } from '@angular/material/expansion'
import { MatInput } from '@angular/material/input'
import { MatDividerModule } from '@angular/material/divider'
import { ViaCepService } from '../../../core/services/address/via-cep/via-cep.service'
import { EmployeeStatusService } from '../../../core/services/employee/employee-status/employee-status.service'
import { EmployeeService } from '../../../core/services/employee/employee/employee.service'
import { AddressTypeService } from '../../../core/services/address/address-type/address-type.service'
import { HabitsService } from '../../../core/services/employee/employee-role/habits.service'
import { HealthUnitService } from '../../../core/services/health-unit/location/health-unit.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import {MatSlideToggle} from '@angular/material/slide-toggle';
import {NgxMaskDirective} from 'ngx-mask';
import {MunicipalityService} from '../../../core/services/municipality/municipality/municipality.service';
import {MatOption} from '@angular/material/core';
import {MatSelect} from '@angular/material/select';
import {MessageService} from '../../../core/services/message/message/message.service';
import {AlertRuleService} from '../../../core/services/alert-rule/alert-rule/alert-rule.service';

@Component({
  selector: 'alert-rule-edit',
  imports: [
    ReactiveFormsModule,
    MatButton,
    MatProgressSpinner,
    MatExpansionModule,
    MatFormFieldModule,
    MatCardModule,
    MatIcon,
    MatInput,
    MatDividerModule,
    MatSlideToggle,
    NgxMaskDirective,
    MatOption,
    MatSelect,
  ],
  templateUrl: './alert-rule-edit.component.html',
  styleUrl: './alert-rule-edit.component.scss',
  providers: [
    ViaCepService,
    EmployeeStatusService,
    EmployeeService,
    HabitsService,
    AddressTypeService,
  ],
  standalone: true,
})
export class AlertRuleEditComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private alertRuleService: AlertRuleService,
    private snackbar: SnackbarCustomService,
    private messageService: MessageService,
    private viaCepService: ViaCepService,
    private dialogRef: MatDialogRef<AlertRuleEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.item = this.data.item
  }

  @Output() responseEdit = new EventEmitter()

  item: any = {}
  form: FormGroup = new FormGroup({})
  listMunicipios: any[] = []

  loading: boolean = false

  ngOnInit(): void {
    this.listMessage()
    this.createForm()
  }
  listMessage(){
    this.messageService.listMessage().subscribe({
      next: (response: any) => {
        if(response.data){
          this.listMunicipios = response.data
        }
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
    })
  }
  close() {
    this.dialogRef.close()
  }

  createModel() {
    return {
      id: this.item.id,
      faixa_inicial: this.form.get('initial')?.value,
      faixa_final: this.form.get('final')?.value,
      mensagem: this.form.get('message')?.value,
    }
  }
  createForm(): void {
    this.form = this.formBuilder.group({
      initial: [this.item.faixa_inicial, [Validators.required]],
      final: [this.item.faixa_final, [Validators.required]],
      message: [this.item.mensagem_id, [Validators.required]]
    })
  }

  editLocation() {
    this.loading = true
    this.alertRuleService.editLocation(this.createModel()).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        this.responseEdit.emit()
        this.close()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
      },
    })
  }
}
